(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterGeVoController', ReiterGeVoController);

    ReiterGeVoController.$inject = [
        '$scope',
        '$log',
        '$timeout',
        '$state',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotKfzService',
        'BasisAngebotService',
        'AngebotModel',
        'AngebotKfzModel',
        'NavigationService',
        'SchluesselWerteUtilsService',
        'MiscUtilsService',
        'IntegrationService',
        'LoadingIndicatorService',
        'ApiService',
        'ExceptionHandlerService',
        'FormFieldUtilsService',
        'AngebotUtilsService'
    ];
    function ReiterGeVoController($scope, $log, $timeout, $state, _, moment, AppConfig, AngebotKfzService, BasisAngebotService, AngebotModel, AngebotKfzModel, NavigationService, SchluesselWerteUtilsService, MiscUtilsService, IntegrationService, LoadingIndicatorService, ApiService, ExceptionHandlerService, FormFieldUtilsService, AngebotUtilsService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            angebotAenderbar = BasisAngebotService.isAngebotAenderbar(angebotVm.angebotModel.angebot, 'ANGEBOT'),
            wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
            integrationParams = IntegrationService.getIntegrationParams(),
            wagniskennziffern = AppConfig.ANGEBOT.kfz.wkz,
            gevos = AppConfig.ANGEBOT.kfz.gevo;

        $log.debug('ReiterGeVoController', vm);

        vm.isGevoVersichererwechselNeuesFahrzeugEditierbar = isGevoVersichererwechselNeuesFahrzeugEditierbar;
        vm.onGevoChanged = onGevoChanged;
        vm.isDirectNavigationToStepErgebnisErlaubt = isDirectNavigationToStepErgebnisErlaubt;
        vm.isPrivatFirmenkundeDisabled = isPrivatFirmenkundeDisabled;
        vm.checkGevoVersichererwechselNeuesFahrzeugValide = checkGevoVersichererwechselNeuesFahrzeugValide;
        vm.isGevo = isGevo;
        vm.isGevoIcisPlusKfzZusaetzlicherVertragErlaubt = isGevoIcisPlusKfzZusaetzlicherVertragErlaubt;
        vm.onTarifauskunftsdatumChanged = onTarifauskunftsdatumChanged;
        vm.onPrivatkundeChanged = onPrivatkundeChanged;

        NavigationService.hideAll();

        if (angebotVm.angebotModel.isDummyModel) {
            LoadingIndicatorService.addInProgress();
            if (integrationParams.angmodus === 'ersatz') {
                AngebotKfzModel.erstelleNeuesAngebotErsatzgeschaeft(integrationParams.tarifauskunftsdatum, null, integrationParams.vertragsnummer, {
                    erzeugeNeuesAngebotImFehlerfall: false
                }).then(function (data) {
                    var wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
                        wkzUrlMapping = _.get(AppConfig.APP.wkzUrlMapping, wkz) || wkz;

                    angebotVm.angebotModel.isDummyModel = false;
                    IntegrationService.setIntegrationParams({
                        angwkz: wkz,
                        angwkzname: wkzUrlMapping
                    });
                    $state.go('.', { angwkzname: wkzUrlMapping }, {
                        location: 'replace',
                        reload: 'rechner.gevo',
                        notify: false
                    });
                    if (_.isFunction(AngebotKfzService.getSchluesselwerte)) {
                        AngebotKfzService.getSchluesselwerte(angebotVm.angebotModel.angebot).then(function (angebotSpezifischeSws) {
                            _.merge(angebotVm.sw, angebotSpezifischeSws);
                        });
                    }

                    BasisAngebotService.getGlobals(angebotVm.angebotModel).then(function (globals) {
                        _.merge(angebotVm, globals);
                        $timeout(function () {
                            activate();
                        });
                    });

                }).catch(function (error) {
                    error = error || {};

                    if (ApiService.isValidationError(error.status) || (ApiService.isInternalServerError(error.status) && ApiService.hasErrors(error))) {
                        ExceptionHandlerService.logRemote(error, true);

                        return NavigationService.goToStep('fehler.409', {
                            reload: false
                        });
                    }
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
            } else {
                AngebotModel.erstelleNeuesAngebot(null, null, {
                    queryParameters: {
                        gevoId: null
                    }
                }).then(function (data) {
                    angebotVm.angebotModel.isDummyModel = false;
                    AngebotModel.angebotVorbelegen(AngebotModel.getLastSavedAngebotDefaults(), true);
                    if (_.isFunction(AngebotKfzService.getSchluesselwerte)) {
                        AngebotKfzService.getSchluesselwerte(angebotVm.angebotModel.angebot).then(function (angebotSpezifischeSws) {
                            _.merge(angebotVm.sw, angebotSpezifischeSws);
                        });
                    }

                    BasisAngebotService.getGlobals(angebotVm.angebotModel).then(function (globals) {
                        _.merge(angebotVm, globals);
                        $timeout(function () {
                            activate();
                        });
                    });
                }).catch(function (error) {
                    error = error || {};

                    if (ApiService.isValidationError(error.status) || (ApiService.isInternalServerError(error.status) && ApiService.hasErrors(error))) {
                        ExceptionHandlerService.logRemote(error, true);

                        return NavigationService.goToStep('fehler.409', {
                            reload: false
                        });
                    }
                }).finally(function () {
                    LoadingIndicatorService.removeInProgress();
                });
            }
        } else {
            activate();
        }

        function activate() {
            vm.berechnenBtnText = angebotAenderbar ? 'Beitrag berechnen' : 'Beitrag anzeigen';

            vm.placeholders = {
                gewerblicheBefoerderung: {
                    banned: [
                        angebotVm.isPrivatPerson ? AppConfig.APP.telefon : AppConfig.APP.telefonFirmenkunde,
                        angebotVm.isPrivatPerson ? '' : ' oder per E-Mail an kfz-firmen@wgv.de'
                    ]
                }
            };

            vm.tarifauskunftsdatum = BasisAngebotService.getTarifauskunftsdatum(angebotVm.angebotModel.angebot) || moment().format(AppConfig.API.dateFormat);
            AngebotKfzService.ermittleGevoId(angebotVm.angebotModel);
            AngebotUtilsService.setRedirectUrlAfterPksLogin(angebotVm.angebotModel.angebot);

            SchluesselWerteUtilsService.fetch('wagniskennziffer', {
                params: {
                    filter: wkz,
                    sort: 'wert'
                }
            }, 'angebotssystem/');

            $scope.$emit('asys:stateChangeSuccess', { state: 'rechner.gevo' });

            if (integrationParams.loginDialog) {
                IntegrationService.setIntegrationParams({
                    loginDialog: false
                });
                $scope.$emit('iplusjs:openLoginDialog');
            }

            $scope.$emit('iplusjs:tracking:trackDefaultEvent', {
                action: 'input',
                trackingProvider: 'wgv',
                formCtrl: vm.gevoForm
            });

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                if (!NavigationService.isErrorStep(toState.name) && !NavigationService.isEntryStep(toState.name)) {
                    toState.resolve.pauseStateChange = ['$q', 'AngebotKfzService', function ($q, AngebotKfzService) {
                        return $q(function (resolve, reject) {
                            AngebotKfzService.korrigiereWerteNachGeVoWechsel(angebotVm.angebotModel.angebot, false);
                            BasisAngebotService.refreshAngebot(angebotVm.angebotModel, {
                                shouldRefreshVertragsdaten: AngebotKfzService.shouldUpdateVertragsdaten(angebotVm.angebotModel.angebot)
                            }).then(function () {
                                AngebotModel.angebotVorbelegen(AngebotModel.getLastSavedAngebotDefaults(), true);

                                wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert');

                                return AngebotKfzService.getSfkKhKv(angebotVm.angebotModel, true).then(function (data) {
                                    angebotVm.schadenfreiheitsklassenZuGevo = {
                                        haftpflicht: data.klassenHaftpflicht,
                                        vollkasko: data.klassenVollkasko
                                    };
                                    BasisAngebotService.getGlobals(angebotVm.angebotModel).then(function (globals) {
                                        _.merge(angebotVm, globals);

                                        resolve();
                                    });
                                }).catch(function () {
                                    reject();
                                });
                            }).catch(function () {
                                reject();
                            });
                        });
                    }];
                }
            });
        }
        function isGevoVersichererwechselNeuesFahrzeugEditierbar() {
            return (
                angebotVm.isAngebotAenderbar('ANGEBOT') &&
                MiscUtilsService.isEmpty(_.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.evbNummer'))
            );
        }
        function onGevoChanged(name, value) {
            NavigationService.setAllDisabled(true);

            if (name === 'gevoFahrzeugwechsel' && value) {
                _.set(angebotVm.angebotModel.formData, 'gevoWeiteresFahrzeug', false);
            } else if (name === 'gevoWeiteresFahrzeug' && value) {
                _.set(angebotVm.angebotModel.formData, 'gevoFahrzeugwechsel', false);
            } else if (name === 'gevoVersichererwechsel' && value === 'versichererwechsel') {
                _.set(angebotVm.angebotModel.formData, 'gevoFahrzeugwechsel', false);
                _.set(angebotVm.angebotModel.formData, 'gevoWeiteresFahrzeug', false);
            }

            AngebotKfzService.ermittleGevoId(angebotVm.angebotModel);

            LoadingIndicatorService.addInProgress();
            FormFieldUtilsService.handlePending(vm.gevoForm, 'gevoWechsel', true);
            vm.reInitTarifauskunftsdatum = true;

            AngebotKfzService.korrigiereWerteNachGeVoWechsel(angebotVm.angebotModel.angebot, true);
            BasisAngebotService.refreshAngebot(angebotVm.angebotModel, {
                shouldRefreshVertragsdaten: AngebotKfzService.shouldUpdateVertragsdaten(angebotVm.angebotModel.angebot)
            }).then(function () {
                AngebotModel.angebotVorbelegen(AngebotModel.getLastSavedAngebotDefaults(), true);
                if (!angebotVm.tarifauskunftsdatumChangedManually && _.get(angebotVm.angebotModel.angebot, 'rahmenDaten.angebotsdatumVorbelegung')) {
                    BasisAngebotService.setTarifauskunftsdatum(angebotVm.angebotModel.angebot, _.get(angebotVm.angebotModel.angebot, 'rahmenDaten.angebotsdatumVorbelegung'));
                    _.set(angebotVm.angebotModel.angebot, 'allgemeineAntragsdaten.versicherungsbeginn', _.get(angebotVm.angebotModel.angebot, 'rahmenDaten.angebotsdatumVorbelegung'));
                }

                wkz = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.wkz.wert');

                return AngebotKfzService.getSfkKhKv(angebotVm.angebotModel, true).then(function (data) {
                    angebotVm.schadenfreiheitsklassenZuGevo = {
                        haftpflicht: data.klassenHaftpflicht,
                        vollkasko: data.klassenVollkasko
                    };
                    BasisAngebotService.getGlobals(angebotVm.angebotModel).then(function (globals) {
                        _.merge(angebotVm, globals);
                        FormFieldUtilsService.handlePending(vm.gevoForm, 'gevoWechsel', false);
                    });
                }).catch(function () {
                    FormFieldUtilsService.handlePending(vm.gevoForm, 'gevoWechsel', false);
                });
            }).catch(function () {
                FormFieldUtilsService.handlePending(vm.gevoForm, 'gevoWechsel', false);
            }).finally(function () {
                LoadingIndicatorService.removeInProgress();
                vm.reInitTarifauskunftsdatum = false;

                FormFieldUtilsService.validate(vm.gevoForm, '$$controls');
            });
        }
        function isDirectNavigationToStepErgebnisErlaubt() {
            return BasisAngebotService.isDirectNavigationToStepErgebnisErlaubt(angebotVm.angebotModel.angebot, vm.gevoForm);
        }
        function isPrivatFirmenkundeDisabled() {
            return !angebotVm.isAngebotAnonym;
        }
        function checkGevoVersichererwechselNeuesFahrzeugValide() {
            return !!_.get(angebotVm.angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug');
        }
        function isGevo(gevo) {
            return AngebotKfzService.isGevo(angebotVm.angebotModel.angebot, gevo);
        }
        function isGevoIcisPlusKfzZusaetzlicherVertragErlaubt() {
            return (
                (
                    !angebotAenderbar &&
                    _.get(angebotVm.angebotModel.angebot, 'gevoId') === gevos.KFZ_ZUSAETZLICHER_VERTRAG // Gevo 2
                ) ||
                (
                    _.get(angebotVm.angebotModel.angebotOriginal, 'gevoId') === gevos.KFZ_ZUSAETZLICHER_VERTRAG // Gevo 2
                ) ||
                (
                    _.includes([
                        wagniskennziffern.MOTORRAD,
                        wagniskennziffern.PKW,
                        wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE
                    ], wkz)
                )
            );
        }

        function onTarifauskunftsdatumChanged(tarifauskunftsdatum) {
            NavigationService.setAllDisabled(true);
            _.set(angebotVm.angebotModel.angebot, 'allgemeineAntragsdaten.versicherungsbeginn', tarifauskunftsdatum);
            if (tarifauskunftsdatum) {
                angebotVm.tarifauskunftsdatumChangedManually = true;
            }
        }

        function onPrivatkundeChanged(privatkunde) {
            NavigationService.setAllDisabled(true);

            if (privatkunde === false) {
                AngebotKfzService.resetDatenPrivatFirmenkunde('privatkunde', angebotVm.angebotModel);
                _.set(angebotVm.angebotModel.angebot, 'antragsteller.mitgliedsart', BasisAngebotService.getConstant('mitgliedsarten').firmenkunde);
            } else {
                AngebotKfzService.resetDatenPrivatFirmenkunde('firmenkunde', angebotVm.angebotModel);
                _.set(angebotVm.angebotModel.angebot, 'antragsteller.mitgliedsart', BasisAngebotService.getConstant('mitgliedsarten').privatkunde);
            }
        }
    }
})();
